import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './scripts/theme';
import { AppContextProvider } from './scripts/context/App';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './scripts/Routes';
import { Global } from "@emotion/react";
import GlobalStyles from "./scripts/globalStyles";
import ErrorBoundary from './components/ErrorBoundary';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <AppContextProvider>
        <AppRouter />
        <ThemeProvider theme={theme}>
          <Global styles={GlobalStyles} />
          <CssBaseline />
          <App />
        </ThemeProvider>
      </AppContextProvider>
    </BrowserRouter>
  </ErrorBoundary>,
);
